import { recoilPersist } from "recoil-persist";

export const { persistAtom: ocPersistAtom } = recoilPersist({
  key: "recoil-persist", // this key is using to store data in local storage
  storage: sessionStorage, // configurate which stroage will be used to store the data
});

export default ocPersistAtom;
